var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    transform: "matrix(-1 0 0 1 32 0)",
    fill: "#598BEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.464 21.5995C17.3445 21.5999 17.2264 21.5735 17.1184 21.5223C17.0104 21.4711 16.9153 21.3963 16.84 21.3035L12.976 16.5035C12.8583 16.3603 12.794 16.1808 12.794 15.9955C12.794 15.8102 12.8583 15.6306 12.976 15.4875L16.976 10.6875C17.1118 10.5241 17.3069 10.4214 17.5185 10.4019C17.73 10.3823 17.9406 10.4477 18.104 10.5835C18.2674 10.7193 18.3701 10.9144 18.3896 11.1259C18.4091 11.3375 18.3438 11.5481 18.208 11.7115L14.632 15.9995L18.088 20.2875C18.1858 20.4049 18.248 20.5479 18.2671 20.6995C18.2862 20.8512 18.2615 21.0051 18.1958 21.1431C18.1302 21.2812 18.0264 21.3975 17.8967 21.4784C17.767 21.5592 17.6168 21.6013 17.464 21.5995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonRight);
export default __webpack_public_path__ + "static/media/Button - right.fc0fe8a7e88866c8059f9252bf3326d5.svg";
export { ForwardRef as ReactComponent };